<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="flex-align-center gap-2">
            <button class="icon-btn-back" aria-label="Close" [pTooltip]="translate?.general.buttons.back.singular" (click)="modalRef.hide()">
                <i class="fa-regular fa-arrow-left"></i>
            </button>

            <h2>New Recipient</h2>
        </div>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="flx-modal__body mp-body">
        <div class="status-field">
            <label class="field-label">Name</label>
            <div class="field-row field-row--auto mb-2">
                <input type="text" pInputText placeholder="Enter Recipient Name">
            </div>
        </div>
        <div class="status-field">
            <label class="field-label">Email</label>
            <div class="field-row field-row--auto mb-2">
                <input type="email" pInputText placeholder="Enter Recipient Email">
            </div>
        </div>

    </div>

    <div class="flx-modal__footer">
        <button type="button"class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        <p-button type="button" [label]="translate?.general.buttons.save.singular" styleClass="h-32"></p-button>
    </div>
</div>